import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { formatString } from '@frontend/sports/common/core/utils/string';

@Component({
    selector: 'bs-over-ask-accept-timeout',
    templateUrl: './betslip-over-ask-accept-time-out.component.html',
    styleUrls: ['./betslip-over-ask-accept-time-out.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BetslipOverAskAcceptTimeOutComponent {
    @HostBinding('class.betslip-over-ask-accept-timeout') hostCssClass = true;
    @Input() messages: { reviewOfferExpires: string };
    @Input() set seconds(value: number) {
        this.shouldHighlight = value <= this.timeoutHighlightThreshold;
        if (!this.messages) {
            return;
        }

        this.reviewOfferExpires = formatString(this.messages.reviewOfferExpires, value.toFixed(0));
    }

    reviewOfferExpires: string;
    readonly timeoutHighlightThreshold = 10;
    shouldHighlight = false;
}
